// The one-shot session-expiry latch (round #101): the api client's fetch wrapper
// raises the event on any intercepted 401; the top-level listener owns the router
// and navigates. The latch collapses N concurrent 401s into ONE redirect and is
// re-armed by the listener when a navigation completes.

export const SESSION_EXPIRED_EVENT = 'tvirt:session-expired'

let notified = false

export function notifySessionExpired() {
  if (notified) {
    return
  }

  notified = true
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
}

export function resetSessionExpiredLatch() {
  notified = false
}
